import { render, staticRenderFns } from "./AppFieldsAsideMenu.vue?vue&type=template&id=03e1abf4&scoped=true&"
import script from "./AppFieldsAsideMenu.vue?vue&type=script&lang=js&"
export * from "./AppFieldsAsideMenu.vue?vue&type=script&lang=js&"
import style0 from "./AppFieldsAsideMenu.vue?vue&type=style&index=0&id=03e1abf4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03e1abf4",
  null
  
)

export default component.exports